import { SagaIterator } from 'redux-saga';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import {
  GlobalActions,
  GlobalAction,
  MasterProduktData,
} from '@ps20-frontend/shop-integration-redux';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { App, Produktlinie } from '@ps20-frontend/frontend-models';
import { Produktlinienname } from '@ps20/bff-models';
import { selectProduktlinien } from '../selectors/produkt.selector';
import { TkvActions } from '../tkvActions';
import { IAppState } from '../appState';
import { selectVorvertragKurzname } from '../selectors/vertragsoptionen.selector';

export function* watchProduktlinienSaga(): SagaIterator {
  yield takeLatest(
    GlobalActions.PRODUKT_RECEIVED,
    safeSaga(updateProduktlinienStatusOnProductReceived, App.TKV_V2),
  );
}

export function* updateProduktlinienStatusOnProductReceived(
  action: GlobalAction<MasterProduktData>,
): SagaIterator {
  const { appId, angebotsId } = action.payload;
  const state: IAppState = yield select();
  if (appId === App.TKV_V2 && angebotsId === state.angebotsId) {
    yield call(updateProduktlinienStatus);
  }
}

export function* updateProduktlinienStatus(): SagaIterator {
  const produktlinien = yield select(selectProduktlinien);
  const vorvertragKurzname = yield select(selectVorvertragKurzname);

  updateSelectedProduktlinie(produktlinien, vorvertragKurzname);
  const changeProduktlinienAction = new TkvActions().produktlinienChanged(produktlinien);
  yield put(changeProduktlinienAction);
}

function updateSelectedProduktlinie(produktlinien: Produktlinie[], vorvertragKurzname?: string) {

  const selectedProduktline = produktlinien.find(
    produktlinie => !produktlinie.deactivated && produktlinie.selected,
  );

  if (selectedProduktline == null) {
    const activatedProduktlinien = produktlinien.filter(produktlinie => !produktlinie.deactivated);
    const produktlinieToActivate = activatedProduktlinien.find(
      produktlinie => produktlinie.produktName === Produktlinienname.KOMFORT,
    );
    if (produktlinieToActivate) {
      produktlinieToActivate.selected = true;
    }  else if (vorvertragKurzname) {
      const selectedPl = produktlinien.find(pl => pl.kurztext === vorvertragKurzname);
      if (selectedPl) {
        selectedPl.selected = true;
      }
    }
  }
}

